import Bowser from 'bowser'

const browserDetection = (): {
  invalidIE: boolean
  invalidSafari: boolean
} => {
  const browser = Bowser.getParser(window.navigator.userAgent)
  const isIE11AndBelow = !!browser.satisfies({ ie: '<=11' })
  const isOldDesktopSafari = !!browser.satisfies({ desktop: { safari: '<10' } })
  const isOldMobileSafari = !!browser.satisfies({ mobile: { safari: '<12' } })
  return {
    invalidIE: isIE11AndBelow,
    invalidSafari: isOldDesktopSafari || isOldMobileSafari,
  }
}

export default browserDetection
